import React from 'react';
import {Container, Row, Col, Button} from 'reactstrap';
import './cloudJumbo.css';

const CloudJumbo = (props) => {
    return(
        <div id='cloud-jumbo' className='pt-5'>
            <Container>
                <Row>
                    <Col>
                        <div className='cloud-jumbo-info'>
                            <h1 className='cj-title'>Cloud Academy</h1>
                            <h3 className='cj-sub'>Expert-Led Training For Your Company</h3>
                            <p className='cj-bodytext'>This course is for individuals and teams sponsored by their company.
                                Our training allows companies to equip their employees with an overall understanding of cloud systems like AWS, Microsoft Azure, and Google Cloud.
                                They will also be able to build solutions on the cloud. Come learn how this differs from traditional development.
                            </p>
                            <Row className='w-100'>
                                {/* <Col xs={{ size: 6}} sm={{ size: 4}} md={{ size: 5}} className='pr-1'>

                                    <Button className='course-hero-start1 w-100 px-1'>Sign Up Now</Button>
                                </Col> */}
                                {/* <Col xs={{ size: 6}} sm={{ size: 4}} md={{ size: 5}} className='px-1'>
                                    <Button className='course-hero-apply1 w-100 px-1'>Request a Quote</Button>
                                </Col> */}
                            </Row>
                        </div>
                    </Col>
                </Row>
                
            </Container>
            
        </div>
            

    );
}

export default CloudJumbo;